import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { get } from "../../api";
import FrameHeader from "../../components/FrameHeader";
import Frame from "../../components/Frame";
import RowItem from "../../components/RowItem";
import LoadingFrame from "../../components/LoadingFrame";
import Space from "../../components/Space";
import styles from "./CustomerAssets.module.scss";

import { AuthContext } from "../../contexts/Auth";

export default function CustomerAssets({ match: { params }, admin = false }) {
  const [loading, setLoading] = useState(true);
  const { state: currentUser } = useContext(AuthContext);
  const [activeAssets, setActiveAssets] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const [inactiveAssets, setInactiveAssets] = useState([]);
  const [inactiveCount, setInactiveCount] = useState(0);

  useEffect(() => {
    var isApiSubscribed = true;
    async function fetchAssets() {
      console.log("Fetching assets for customer:", params);
      const finalParams = params.params !== undefined ? params.params : params;
      const [active, inactive] = await Promise.all([
        get("/assetsAdmin", {
          active: "true",

          customer_id: finalParams.id,
        }),
        get("/assetsAdmin", {
          active: "false",

          customer_id: finalParams.id,
        }),
      ]);

      if (isApiSubscribed) {
        setActiveAssets(active || []);
        setActiveCount(active?.length || 0);
        setInactiveAssets(inactive || []);
        setInactiveCount(inactive?.length || 0);
        setLoading(false);
      }
    }
    fetchAssets();

    return () => {
      isApiSubscribed = false;
    };
  }, [admin]);

  return loading ? (
    <LoadingFrame />
  ) : (
    <>
      <Space size="l">
        <FrameHeader title={`Active assets (${activeCount})`} />
        <Frame padding={0}>
          {activeAssets?.length ? (
            activeAssets.map((asset) => (
              <RowItem
                key={asset.id}
                title={asset.name}
                to={`/assets/${asset.id}`}
              />
            ))
          ) : (
            <div className={styles.empty}>No active devices</div>
          )}
        </Frame>
      </Space>
      <FrameHeader title={`Inactive assets (${inactiveCount})`} />
      <Frame padding={0}>
        {inactiveAssets?.length ? (
          inactiveAssets.map((asset) => (
            <RowItem
              key={asset.id}
              title={asset.name}
              to={`/assets/${asset.id}`}
            />
          ))
        ) : (
          <div className={styles.empty}>No inactive devices</div>
        )}
      </Frame>
      <Space />
    </>
  );
}
